module.exports = __webpack_public_path__ + "media/images/category/feature/profile/profile-dawn-8c1af76a8a8c54eb9ad95346e78d0333.jpg";